module.exports = __webpack_public_path__ + "media/images/icon/toast-success-ce3c45e43d2a8cd3c7210ccd6e37a6c9.png";